import React from 'react';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'white' | 'warm' | 'navy';
}
export function Section({
  children,
  className = '',
  id,
  background = 'warm'
}: SectionProps) {
  const backgrounds = {
    white: 'bg-sage-50 text-body',
    warm: 'bg-sage-100 text-body',
    navy: 'bg-ink-900 text-sage-50'
  };
  return <section id={id} className={`py-20 md:py-32 px-6 md:px-12 lg:px-24 overflow-hidden ${backgrounds[background]} ${className}`} data-id="element-487">
      <div className="max-w-7xl mx-auto w-full" data-id="element-488">{children}</div>
    </section>;
}